import { Injectable } from '@angular/core';
import { PigeonholePackage } from '../../../models/Pigeonhole';
import { PigeonholeTooltipContent } from 'src/app/pages/map/map-tooltip/map-tooltip.types';

@Injectable({
  providedIn: 'root'
})
export class PigeonholeTooltipService {
  private packagesByPosition = new Map<string, PigeonholePackage[]>();

  constructor() {}

  public processCratesAndLevels(packages: PigeonholePackage[]): void {
    this.packagesByPosition.clear();
    
    for (const pkg of packages) {
      const pigeonholeId = pkg.pigeonholeId;
      
      if (!this.packagesByPosition.has(pigeonholeId)) {
        this.packagesByPosition.set(pigeonholeId, []);
      }
      
      this.packagesByPosition.get(pigeonholeId).push(pkg);
    }
  }

  public getTooltipContent(pigeonholeId: string, groundPositionType?: string): PigeonholeTooltipContent {
    const packages = this.packagesByPosition.get(pigeonholeId);
    
    if (!packages || packages.length === 0) {
      return { 
        pallets: [], 
        palletQty: 0, 
        empty: true,
        groundGroup: groundPositionType
      };
    }

    const pallets = packages.map((pkg, index) => ({
      products: pkg.skuGroups.map(group => ({
        sku: group.sku,
        quantity: group.quantity * (group.packSize || 1)
      })),
      skuQty: pkg.skuGroups.length
    }));

    return {
      pallets,
      palletQty: packages.length,
      empty: false,
      groundGroup: groundPositionType
    };
  }
}
